import * as React from "react";
import * as kea from "kea-react";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { RxfyScalar } from "react-rxk";
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


export interface Props {
    value: RxfyScalar<string>;
    onChange?: (x: string) => void;
    readonly?: boolean;
    error?: kea.FieldError;
    label?: string;
}
export class FolioFactura extends React.PureComponent<Props> {
    render() {
        return <kea.Text
            value={this.props.value}
            onChange={this.props.onChange}
            error={this.props.error}
            label={this.props.label == undefined ? "Folio" : this.props.label}
            addon={<i className={fa("qrcode")} />}
            style={{ fontFamily: "monospace" }}
         />
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/foliofactura.tsx